import React from "react";
import { Grid, List } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { Box } from "@material-ui/core";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import CMLinkDropDown from "../CMLinkDropDown";
const Datacell = ({
  executionLink,
  allignment,
  submenu,
  name,
  path,
  executionName,
  customStyle
}) => {
  return (
    <Box
      height={70}
      width={"85%"}
      display="flex"
      alignItems="center"
      justifyContent={executionLink ? "space-around" : "center"}
      className={allignment === "left" ? "slide-right" : "slide-left"}
      sx={{
        bgcolor: "#ffffff",
        border: "0.5px solid rgba(0, 0, 0, 0.125)",
        borderRadius: "0.25rem",
        fontSize: "1.2rem",
        marginBottom: "20px",
        //float: ele.allignment === "left" ? "left" : "right",
        "&:hover": {
          background: "#D1FE7D",
          border: "solid #E0FCAC",
          cursor: "pointer",
        },
        ...customStyle
      }}
    >
      {submenu && submenu.length ? (
        <CMLinkDropDown name={name} menus={submenu} />
      ) : (
        <Link to={path}>{name}</Link>
      )}

      {executionLink && (
        <Link to={executionLink}>{executionName || "Executions"}</Link>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    width: "75%",
    border: "1px solid rgba(0,0,0,0.125)",
    background: "#ffffff",
    paddingBottom: "2rem",
    position: "relative",
    borderRadius: "5px",
    top:'calc(50% - 40px)',
    left:"50%",
    transform:'translate(-50%,-50%)'
  },
  reportRoot: {
    position: "relative",
   // left: "calc(50% - 100px)",
    width: "200px",
    margin: "20px",
  },
  color: {
    background: "rgb(117, 122, 247)",
    color: "#ffffff",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "1.5rem",
    borderTopRightRadius: "5px",
  },
  item: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  containerDirection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  spaceContainer: {
    justifyContent: "space-between",
    paddingBottom:"0px",
    marginBottom:"0px"
  },
}));
const WelcomCM = (props) => {
  const pathAndName = [
    {
      name: "Base Scenario Collection",
      path: "/close_loop_cm_scenario_collection_enhanced",
      allignment: "left",
    },

    {
      name: "Scenario Group",
      path: "/close_cm_loop_scenario_group",
      allignment: "left",
    },

    {
      name: "CAD Topology",
      path: "/close_loop/close_cm_loop_topology",
      allignment: "left",
    },

    {
      name: "Executions",
      path: "/close_loop/execution_listing",
    },
  ];
  let pathAndNamePG = [
    {
      name: "Proving Ground",
      path: "/open-loop-pg",
      allignment: "right",
      // executionLink: "/open-loop-pr",
      // executionName: "Public Road (PR)",
      submenu: [
        {
          id: 1,
          menuName: "Execution Mode",
          menuDescription: "To Setup sub departments",
          path: "/open-loop-pg",
          tooltip: "Register",
        },
        {
          id: 2,
          menuName: "Reporting Mode",
          menuDescription: "To Setup sub departments",
          path: "/reporting-mode?open-loop-type=pg",
          tooltip: "View Users",
        },
      ],
    },
    {
      name: "Scenario Group",
      path: "/open_loop_scenario_group?open-loop-type=PG",
      allignment: "right",
    },
    {
      name: "CAD Topology",
      path: "/cm_open_loop_topology?open-loop-type=PG",
      allignment: "right",
    },
    {
      name: "Executions",
      path: "/open_loop/execution_listing?open-loop-type=PG",
      allignment: "right",
    },
  ];
  const pathAndNamePR = [
    {
      name: "Public Road",
      path: "/open-loop-pr",
      allignment: 'right',
      submenu: [
        {
          id: 1,
          menuName: "Execution Mode",
          menuDescription: "To Setup sub departments",
          path: "/open-loop-pr",
        },
        {
          id: 2,
          menuName: "Reporting Mode",
          menuDescription: "To Setup sub departments",
          path: "/reporting-mode?open-loop-type=pr",
        },
      ],
    },
    {
      name: "Scenario Group",
      path: "/open_loop_scenario_group?open-loop-type=PR",
    },
    {
      name: "CAD Topology",
      path: "/cm_open_loop_topology?open-loop-type=PR",
    },
    {
      name: "Executions",
      path: "/open_loop/execution_listing?open-loop-type=PR",
    },
  ];
  const reporting = [
    {
      name: "Criteria Mapping",
      path: "close_loop_criteria_masters",
    },
    {
      name: "Download Archive",
      path: "download_archive_list",
    },
  ];
  const classes = useStyles();
  return (
    <div style={{height:"100%"}}>
      <Breadcrumb>
        <Breadcrumb.Item href="">
          <Link to="navigate_new">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="/welcome" active>
          {" "}
          Welcome
        </Breadcrumb.Item>
      </Breadcrumb>
      <Grid
        className={classes.root}
        container
        spacing={3}
        display="flex"
        justifyContent="space-between"
      >
        <Grid item xs={12} className={classes.header + " " + classes.color}>
          <Grid item xs={4} className={classes.item + " " + "slide-right"}>
            <h3>
              <b>Close Loop</b>
            </h3>
          </Grid>
          <Grid
            item
            xs={8}
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box className={classes.item}>
              <h3>
                <b>Open Loop</b>
              </h3>
            </Box>

            <Grid sx={12} item className={classes.item}>
              <Grid item xs={6} className={classes.item}>
                <h4>
                  <b>PG</b>
                </h4>
              </Grid>
              <Grid item xs={6} className={classes.item}>
                <h4>
                  <b>PR</b>
                </h4>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={
            classes.item + " " + classes.header + " " + classes.spaceContainer
          }
          item
          xs={12}
        >
          <Grid item xs={4} className={classes.containerDirection}>
            {pathAndName.map((ele) => (
              <Datacell
                executionLink={ele.executionLink}
                allignment={ele.allignment}
                submenu={ele.submenu}
                name={ele.name}
                path={ele.path}
                executionName={ele.executionName}
              />
            ))}
          </Grid>
          <Grid item xs={4} className={classes.containerDirection}>
            {pathAndNamePG.map((ele) => (
              <Datacell
                executionLink={ele.executionLink}
                allignment={ele.allignment}
                submenu={ele.submenu}
                name={ele.name}
                path={ele.path}
                executionName={ele.executionName}
              />
            ))}
          </Grid>

          <Grid item xs={4} className={classes.containerDirection}>
            {pathAndNamePR.map((ele) => (
              <Datacell
                executionLink={ele.executionLink}
                allignment={ele.allignment}
                submenu={ele.submenu}
                name={ele.name}
                path={ele.path}
                executionName={ele.executionName}
              />
            ))}
          </Grid>
        </Grid>
       <hr style={{width:"100%",color:"#dbdbdb",border:"0.5px solid"}}/>
        <Grid
              className={classes.header}
              item
              xs={12}
              style={{
                justifyContent: "left",
                 margin:"0px",
              }}
        >
           
                {reporting.map((ele) => (
                 <Grid item xs={4} className={classes.containerDirection}
                 style={{justifyContent:"left"}}
                 >
                      <Datacell
                      customStyle={{borderRadius:"10px",
                        border:"3px solid rgb(0 0 0 / 13%)"
                      }}
                      name={ele.name}
                      path={ele.path}
                      executionName={ele.executionName}
                    />
                </Grid>
                ))}
           
            {/* <Box
              height={120}
              display="flex"
              flexDirection="column"
              className="report-box"
              sx={{
                bgcolor: "#ffffff",
                border: "0.5px solid rgba(0, 0, 0, 0.125)",
                borderRadius: "0.25rem",
                fontSize: "1rem",
                top: "42%",
                left: "40%",
                width: "100%",
                "&:hover": {
                  background: "#b7ff32",
                  border: "0.5px solid #E0FCAC",
                  cursor: "pointer",
                },
              }}
            >
              <Box
                display="flex"
                justifyContent="center"
                sx={{ margin: "10px 0 6px 0" }}
              >
                <h5>
                  <b>REPORTS</b>
                </h5>
              </Box>
              {reporting.map((ele) => (
                <Box display="flex" justifyContent="center">
                  <Link to={ele.path}>{ele.name}</Link>
                </Box>
              ))}
            </Box> */}
          </Grid>
      </Grid>
    </div>
  );
};

export default WelcomCM;
